import { type PropsWithChildren, useMemo } from 'react';

import { AuthProvider as ReactAuthProvider } from 'react-oidc-context';
import { useLocation } from 'react-router';

import oidcConfig from '@/lib/auth/oidcConfig';
import paths from '@/lib/paths';
import useUpdateMetadata from '@/mutations/useUpdateMetadata';

import { useOffice } from './OfficeProvider';

export default function AuthProvider({ children }: PropsWithChildren) {
  const location = useLocation();
  const { isOfficeEnvironment } = useOffice();

  const skipSigninCallback = useMemo(
    () => location.pathname === paths.login.callback && isOfficeEnvironment,
    [isOfficeEnvironment, location.pathname],
  );

  const { mutateAsync: updateMetadata } = useUpdateMetadata();

  return (
    <ReactAuthProvider
      {...oidcConfig}
      // We don't want to use up the code in the child dialog!
      // We want to send it to the parent where it will be consumed by the library.
      skipSigninCallback={skipSigninCallback}
      onSigninCallback={() => {
        updateMetadata({ outlookSidebarLastLoggedInAt: new Date() });
      }}
    >
      {children}
    </ReactAuthProvider>
  );
}
